import { memo } from 'react';
import classes from 'classnames';
import styles from './Subtitle.module.scss';

export type SubtitleProps = {
  dataTest?: string;
  heading?: string;
  text?: string;
  htmlContent?: string;
  inline?: boolean;
  className?: string;
  textClassName?: string;
  headingClassName?: string;
};

export default memo(function Subtitle({
  dataTest = 'subtitle',
  heading,
  text,
  htmlContent,
  inline = true,
  className,
  textClassName,
  headingClassName,
}: SubtitleProps) {
  return (
    <div className={classes(styles.container, className)}>
      {heading && (
        <span
          className={classes([styles.heading, headingClassName])}
          data-test={`${dataTest}-heading`}
        >
          {heading}:{' '}
        </span>
      )}
      {heading && !inline && <br />}
      <span
        className={classes([textClassName])}
        data-test={`${dataTest}-content`}
        dangerouslySetInnerHTML={
          htmlContent
            ? {
                __html: htmlContent,
              }
            : undefined
        }
      >
        {text}
      </span>
    </div>
  );
});
